import React, { Component } from "react";
import Layout from "./../layouts/Index";
import { withRouter } from "react-router-dom";
import { Formik } from "formik";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  Row,
  Col,
  Container,
  Form,
  Button,
  Card,
} from "react-bootstrap";
import { getProduct, editProduct } from "./../../store/actions/ProductActions";
import { getAllColors } from "./../../store/actions/ColorActions";
import { getAllSizes, addSize } from "./../../store/actions/SizeActions";
import { createSchema } from "./../../helpers/validation/product";
import { instance, setAuthToken } from "./../../helpers/instance";
import BlockLoader from "./../contentloaders/BlockLoader";
import CreatableSelect from "react-select/creatable";
import Dropzone from "react-dropzone";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class Edit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,

      colors: [],

      selectedColors: [],

      categories: [],

      files: [],

      images: [],

      sizes: [],

      selectedSizes: [],

      previews: [],

      checked: false,

      charLimit: 60,
    };
  }

  componentDidMount = async () => {
    const {
      match: { params },
    } = this.props;

    this.setState({ loading: true });

    await this.getCategories();

    await this.getAllColors();

    await this.getAllSizes();

    // console.log(params);

    const result = await this.props.getProduct(params.id);

    if (result) {
      if (result.varying_sizes === 1) {
        this.setState({ checked: true });
      }

      let images = [];

      if (result.images !== undefined || result.images !== null) {
        images = images.concat(result.images);
      }

      this.setState({ images });

      // console.log(result);

      this.getSelectedColors(result.readable_colors);

      this.getSelectedSizes(result.readable_sizes);

      this.setState({ loading: false });
    }
  };

  getCategories = async () => {
    try {
      setAuthToken(instance);

      const response = await instance.get("categories");

      if (response.data !== "") {
        // console.log(response.data);

        this.setState({ categories: response.data.categories });
      }
    } catch (error) {
      console.log(error);
    }
  };

  getSelectedColors = (allColors) => {
    const { colors } = this.state; // available options: [{value, label}]
    let existingColors = [];

    if (allColors) {
      allColors.forEach((color) => {
        // Try to match against loaded options
        let match = colors.find((c) => c.value === color.id);

        if (match) {
          existingColors.push(match);
        } else {
          // Fallback: push object so labels always show
          existingColors.push({
            value: color.id,
            label: color.label || color.name || String(color.id),
          });
        }
      });
    }

    this.setState({ selectedColors: existingColors });
  };

  getSelectedSizes = (allsizes) => {
    const { sizes } = this.state; // available options: [{value, label}]
    let existingSizes = [];

    if (allsizes) {
      allsizes.forEach((size) => {
        let match = sizes.find((s) => s.value === size.id);

        if (match) {
          existingSizes.push(match);
        } else {
          existingSizes.push({
            value: size.id,
            label: size.label || size.name || String(size.id),
          });
        }
      });
    }

    this.setState({ selectedSizes: existingSizes });
  };

  getAllColors = async () => {
    try {
      const result = await this.props.getAllColors();
      if (result) {
        const colors = result.colors.map((c) => ({
          value: Number(c.id),
          label: c.label,
        }));
        this.setState({ colors });
      }
    } catch (error) {
      console.log(error);
    }
  };

  getAllSizes = async () => {
    try {
      const result = await this.props.getAllSizes();
      if (result) {
        const sizes = result.sizes.map((s) => ({
          value: Number(s.id),
          label: s.label,
        }));
        this.setState({ sizes });
      }
    } catch (error) {
      console.log(error);
    }
  };

  update = async (data) => {
    this.setState({ loading: true });
    try {
      const { files, images, checked } = this.state;

      let imgs = [];

      const {
        products: { product },
        history,
      } = this.props;

      if (images) {
        imgs = imgs.concat(images);
      }

      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          let formData = new FormData();
          formData.append("file", files[i]);

          const response = await instance.post("upload", formData);
          if (response.data !== "") {
            imgs.push(response.data.file);
          }
        }
      }

      data.images = imgs;

      // --- COLORS ---
      let finalColors = [];
      if (data.colors && data.colors.length > 0) {
        for (const c of data.colors) {
          if (!c.value || c.value === c.label) {
            // New color manually added by the user
            const response = await this.props.addColor({ label: c.label });
            if (response?.id) {
              finalColors.push(response.id.toString());
            }
          } else {
            finalColors.push(c.value.toString());
          }
        }
        data.colors = finalColors;
      } else {
        this.setState({ loading: false });
        return toast.error("Colors is required !", {
          position: "bottom-center",
        });
      }

      // --- SIZES ---
      let finalSizes = [];
      if (data.sizes && data.sizes.length > 0) {
        for (const c of data.sizes) {
          if (!c.value || c.value === c.label) {
            // New size manually added by the user
            const response = await this.props.addSize({ label: c.label });
            if (response?.id) {
              finalSizes.push(response.id.toString());
            }
          } else {
            finalSizes.push(c.value.toString());
          }
        }
        data.sizes = finalSizes;
      } else {
        this.setState({ loading: false });
        return toast.error("Sizes is required !", {
          position: "bottom-center",
        });
      }

      // --- Varying Sizes ---
      data.varying_sizes = checked ? 1 : 0;

      // --- Submit Update ---
      const result = await this.props.editProduct(product.id, data);

      if (result) {
        this.setState({ loading: false });
        toast.success("Product Edited Successfully !", {
          position: "bottom-center",
        });
        return history.push(`/admin/products/${product.id}`);
      }
    } catch (error) {
      this.setState({ loading: false });
      if (error?.response?.data?.message) {
        toast.error(`${error?.response?.data?.message}`, {
          position: "bottom-center",
        });
      }
    }
  };


  deleteS3Image = async (url) => {
    try {
      // console.log(url);

      const { images } = this.state;

      let photos = images.filter((img) => {
        return img !== url;
      });

      // console.log(photos);

      this.setState({ loading: true });

      setAuthToken(instance);

      // console.log(photos);

      const response = await instance.post("delete", { url });

      if (response.data !== "") {
        this.setState({ images: photos, loading: false });

        // console.log(response.data);
      }
    } catch (error) {
      console.log(error);

      this.setState({ loading: false });
    }
  };

  deleteImage = (file) => {
    const { previews } = this.state;

    let images = previews.filter((img) => {
      return img !== file;
    });

    this.setState({ previews: images });
  };

  previewFiles = (files) => {
    let data = [];

    for (let i = 0; i < files.length; i++) {
      // console.log(files[i]);

      let uri = URL.createObjectURL(files[i]);

      // console.log(uri);

      data.push(uri);

      //   this.fileArray.push(URL.createObjectURL(this.fileObj[0][i]))
    }

    this.setState({ previews: data });
  };

  removeTags = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();

    // Regular expression to identify HTML tags in
    // the input string. Replacing the identified
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/gi, "");
  };

  render() {
    const {
      products: { product },
    } = this.props;

    // console.log(product);

    const {
      loading,
      categories,
      previews,
      images,
      charLimit
    } = this.state;

    return (
      <Layout>
        <Col sm="12" style={{ minHeight: "80vh", padding: "1.5em 0" }}>
          <Container>
            <Row>
              <Col sm="12">
                <h4>Edit Product</h4>
              </Col>
              <Col sm="12">
                <Card>
                  <Card.Body style={{ position: "relative", minHeight: "200px" }}>
                    {loading && (
                      <BlockLoader
                        innerHeight="100%"
                        innerWidth="100%"
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          width: "100%",
                          height: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          zIndex: 10,
                        }}
                      />
                    )}
                    <Formik
                      enableReinitialize
                      initialValues={{
                        name: product.name || "",
                        description: product.description || "",
                        status: product.status ?? 0,
                        colors: this.state.selectedColors,   // ✅ always objects {value,label}
                        category_id: product.category_id || "",
                        sizes: this.state.selectedSizes,     // ✅ always objects {value,label}
                      }}
                      validationSchema={createSchema}
                      onSubmit={async (
                        values,
                        { setSubmitting, resetForm }
                      ) => {
                        this.update(values);
                      }}
                    >
                      {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldValue,
                        setFieldTouched,
                      }) => (
                        <Form
                          noValidate
                          onSubmit={(e) => {
                            e.preventDefault();

                            // console.log('Form Submitted !');

                            handleSubmit();
                          }}
                        >
                          <Row>
                            <Col sm="6">
                              <Form.Group
                                style={{ marginTop: "1em" }}
                                controlId="formBasicEmail"
                              >
                                <Form.Label>Name</Form.Label>

                                <Form.Control
                                  type="text"
                                  placeholder="Product Name"
                                  name="name"
                                  isValid={touched.name && !errors.name}
                                  isInvalid={errors.name && touched.name}
                                  value={values.name}
                                  onChange={(e) => {
                                    let txt = e.target.value;

                                    // Only allow letters, numbers, and spaces
                                    const filtered = txt.replace(/[.,*#@!$%^&()\-_=+[\]{};:'"<>?/\\|`~]/g, '');

                                    if (filtered.length <= charLimit) {
                                      setFieldValue("name", filtered);
                                    }
                                  }}
                                />

                                {errors.name && touched.name && (
                                  <Form.Control.Feedback type="invalid">
                                    {errors.name}
                                  </Form.Control.Feedback>
                                )}

                                { <span style={{ paddingTop: '5px', fontSize: '12px' }}>{charLimit - values.name.length} characters remaining.</span>}
                              </Form.Group>
                            </Col>
                            <Col sm="6">
                              <Form.Group
                                style={{ marginTop: "1em" }}
                                controlId="category_id"
                              >
                                <Form.Label>Category</Form.Label>

                                <Form.Control
                                  as="select"
                                  isValid={
                                    touched.category_id && !errors.category_id
                                  }
                                  value={values.category_id}
                                  isInvalid={
                                    errors.category_id && touched.category_id
                                  }
                                  name="category_id"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                >
                                  <option value="">Choose ...</option>

                                  {categories.map((category, i) => (
                                    <option
                                      key={i}
                                      value={category.id}
                                      selected={
                                        category.id === values.category_id
                                          ? true
                                          : false
                                      }
                                    >
                                      {category.name}
                                    </option>
                                  ))}
                                </Form.Control>

                                {errors.category_id &&
                                  touched.category_id && (
                                    <Form.Control.Feedback type="invalid">
                                      {errors.status}
                                    </Form.Control.Feedback>
                                  )}
                              </Form.Group>
                            </Col>
                          </Row>

                          <Form.Group
                            style={{ marginTop: "1em" }}
                            controlId="formBasicPassword"
                          >
                            <Form.Label>Description</Form.Label>

                            {/* <FormControl as="textarea" aria-label="With textarea" name="description" isValid={touched.description && !errors.description} isInvalid={errors.description && touched.description} value={values.description} onChange={handleChange} /> */}

                            <ReactQuill
                              theme="snow"
                              value={values.description}
                              onChange={(data) =>
                                setFieldValue("description", data)
                              }
                            />

                            {errors.description && touched.description && (
                              <Form.Control.Feedback type="invalid">
                                {errors.description}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          {/* <Form.Group controlId="source">

                                                      <Form.Label>Source</Form.Label>

                                                      <Form.Control type="text" placeholder="Product Source" name="source" isValid={touched.source && !errors.source} isInvalid={errors.source && touched.source} value={values.source} onChange={handleChange} />

                                                      {errors.source && touched.source && <Form.Control.Feedback type="invalid">{errors.source}</Form.Control.Feedback>}

                                                  </Form.Group> */}

                          <Form.Group
                            style={{ marginTop: "1em" }}
                            controlId="formBasicEmail"
                          >
                            <Form.Label>Photo(s)</Form.Label>

                            {/* <Form.Control type="file" name="file" accept='image/*' multiple onChange={async (e) => { 
                                                          
                                                          // console.log(e.target.files);

                                                          this.previewFiles(e.target.files);

                                                          this.setState({ files: e.target.files });
                                                          
                                                      }} /> */}

                            <Dropzone
                              accept="image/*"
                              onDrop={(acceptedFiles) => {
                                // console.log(acceptedFiles);

                                this.previewFiles(acceptedFiles);

                                this.setState({ files: acceptedFiles });
                              }}
                            >
                              {({ getRootProps, getInputProps }) => (
                                <section>
                                  <div
                                    {...getRootProps()}
                                    style={{
                                      flex: 1,
                                      flexDirection: "column",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "20px",
                                      borderWidth: 2,
                                      borderRadius: 2,
                                      borderColor: "#eee",
                                      borderStyle: "dashed",
                                      backgroundColor: "#fafafa",
                                      color: "#bdbdbd",
                                      outline: "none",
                                      transition: "border .24s ease-in-out",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <input {...getInputProps()} />

                                    <p
                                      style={{
                                        textAlign: "center",
                                        marginTop: "1em",
                                      }}
                                    >
                                      Drag 'n' drop some files here, or click
                                      to select files
                                    </p>
                                  </div>
                                </section>
                              )}
                            </Dropzone>

                            <div
                              style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "flex-start",
                                margin: "15px 0",
                              }}
                            >
                              {images !== undefined &&
                                images.length > 0 &&
                                images.map((image, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      height: "80px",
                                      width: "80px",
                                      backgroundImage: `url("${image}")`,
                                      backgroundSize: "cover",
                                      margin: "0 6px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      this.deleteS3Image(image);
                                    }}
                                  >
                                    <Button
                                      variant="danger"
                                      type="button"
                                      size="sm"
                                      style={{
                                        postition: "absolute",
                                        right: "0",
                                        margin: "5px",
                                      }}
                                    >
                                      x
                                    </Button>
                                  </div>
                                ))}

                              {previews.length > 0 &&
                                previews.map((image, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      height: "80px",
                                      width: "80px",
                                      backgroundImage: `url("${image}")`,
                                      backgroundSize: "cover",
                                      margin: "0 6px",
                                    }}
                                    onClick={() => {
                                      this.deleteImage(image);
                                    }}
                                  >
                                    <Button
                                      variant="danger"
                                      type="button"
                                      size="sm"
                                      style={{
                                        postition: "absolute",
                                        right: "0",
                                        margin: "5px",
                                      }}
                                    >
                                      x
                                    </Button>
                                  </div>
                                ))}
                            </div>
                          </Form.Group>
                          <Row>
                            <Col sm="6">
                              <Form.Group
                                style={{ marginTop: "1em" }}
                                controlId="colors"
                              >
                                <Form.Label>Colors</Form.Label>

                                <CreatableSelect
                                  value={values.colors}
                                  options={this.state.colors}
                                  isMulti
                                  onChange={(value) => {
                                    setFieldValue("colors", value);
                                  }}
                                  onBlur={() => {
                                    setFieldTouched("colors", true);
                                  }}
                                  touched={touched.colors}
                                />

                                {/* {errors.colors && touched.colors && <Form.Control.Feedback type="invalid">{errors.colors}</Form.Control.Feedback>} */}
                              </Form.Group>
                            </Col>
                            <Col sm="6">
                              <Form.Group
                                style={{ marginTop: "1em" }}
                                controlId="sizes"
                              >
                                <Form.Label>Sizes</Form.Label>

                                <CreatableSelect
                                  value={values.sizes}
                                  options={this.state.sizes}
                                  isMulti
                                  onChange={(value) => {
                                    setFieldValue("sizes", value);
                                  }}
                                  onBlur={() => {
                                    setFieldTouched("sizes", true);
                                  }}
                                  touched={touched.sizes}
                                />
                              </Form.Group>
                            </Col>
                          </Row>
                          <Form.Group
                            style={{ marginTop: "1em" }}
                            controlId="status"
                          >
                            <Form.Label>Status</Form.Label>

                            <Form.Control
                              as="select"
                              isValid={touched.status && !errors.status}
                              defaultValue={values.status}
                              isInvalid={errors.status && touched.status}
                              name="status"
                              onChange={handleChange}
                              onBlur={handleBlur}
                            >
                              <option
                                value={1}
                                selected={1 === values.status ? true : false}
                              >
                                Activated
                              </option>

                              <option
                                value={0}
                                selected={0 === values.status ? true : false}
                              >
                                Deactivated
                              </option>
                            </Form.Control>

                            {errors.status && touched.status && (
                              <Form.Control.Feedback type="invalid">
                                {errors.status}
                              </Form.Control.Feedback>
                            )}
                          </Form.Group>

                          <Form.Group
                            style={{ marginTop: "1em" }}
                            controlId="varying_sizes"
                          >
                            <Form.Check
                              checked={this.state.checked}
                              onChange={(e) => {
                                this.setState({ checked: e.target.checked });
                              }}
                              type="checkbox"
                              label="Varying Sizes Determine Price"
                            />
                          </Form.Group>

                          <Button
                            style={{ marginTop: "1em" }}
                            variant="primary"
                            type="submit"
                            disabled={loading}
                          >
                            Edit Product
                          </Button>
                        </Form>
                      )}
                    </Formik>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Col>
      </Layout>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    products: state.products,
  };
};

export default connect(mapStateToProps, {
  getProduct,
  editProduct,
  getAllColors,
  getAllSizes,
  addSize,
})(withRouter(Edit));
